import { FC } from "react"
import { useGetLabrUserBalanceQuery } from "@/store/apis/userAPI"
import { useGetStarCourseQuery } from "@/store/apis/withdrawalAPI"
import styles from "./CommissionsTab.module.scss"
import { CommissionCard } from "./ui"

export const CommissionsTab: FC = () => {
  const {
    data: balance,
    isLoading: isBalanceLoading,
    isError: isBalanceError
  } = useGetLabrUserBalanceQuery()

  const { data: starCourse, isLoading: isCourseLoading } =
    useGetStarCourseQuery()

  return (
    <div className={styles.CommissionsTab}>
      <CommissionCard
        stars={balance?.star}
        starsToUsdRate={starCourse?.starsToUsdRate}
        isLoading={isBalanceLoading || isCourseLoading}
        isError={isBalanceError}
      />
    </div>
  )
}
